// Copyright © 2021 Move Closer
export { ICommentService } from '@modules/services/comment';
export const CommentServiceType = Symbol.for('ICommentService');
